import { createSvgComponent } from "../../icon/createSvgComponent";
import CustomPolicy from "@core/icon/assets/custom-policy.svg";
export default createSvgComponent(CustomPolicy);